import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useLocalStorage } from '@grandvisionhq/lib-utils-w3c';
import { getDisplayName } from '@grandvisionhq/utils';

function withScridId() {
    return (PageComponent)=>{
        const displayName = getDisplayName(PageComponent);
        const WithScrid = (pageProps)=>{
            const [scridId, setScridId] = useLocalStorage('SCRID_KEY');
            const { scrid  } = pageProps;
            React.useEffect(()=>{
                if (scrid && scridId !== scrid) {
                    setScridId(scrid);
                }
            // eslint-disable-next-line react-hooks/exhaustive-deps
            }, [
                scrid
            ]);
            return /*#__PURE__*/ React.createElement(PageComponent, swcHelpers.extends({}, pageProps));
        };
        WithScrid.getInitialProps = function() {
            var _ref = swcHelpers.asyncToGenerator(function*(ctx) {
                const { scrid  } = ctx.query || {};
                if (typeof PageComponent.getInitialProps === 'function') {
                    const pageProps = yield PageComponent.getInitialProps(ctx);
                    return swcHelpers.objectSpread({}, pageProps, {
                        scrid
                    });
                }
                return {
                    scrid
                };
            });
            return function(ctx) {
                return _ref.apply(this, arguments);
            };
        }();
        WithScrid.displayName = `WithScridId(${displayName})`;
        return WithScrid;
    };
}

export { withScridId };
//# sourceMappingURL=with-scrid.js.map
